module.exports = __webpack_public_path__ + "img/JEEP.76eed8d.jpg";